import { Box, ColorOptions, TextNew } from '@jfs/ui-new'
import { isEmpty } from '@jfs/utils'
import React from 'react'
import { styles } from './index'

export const EnableVpa = ({ title, onPress }: any) => {
  return (
    <>
      {!isEmpty(title?.toString() ?? '') && (
        <Box underlayColor={'TRANSPARENT'} justify={'center'} onPress={onPress}>
          <TextNew {...styles.labelStyle} color={'PRIMARY'} fontFamily={'jiotype-medium'} title={title} />
        </Box>
      )}
    </>
  )
}
